export default __webpack_public_path__ + "static/Punk-536f385654aa87496972c7e0a5f8b769.png";